module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "players-template"
  }, [_c('table-data', {
    staticClass: "players",
    attrs: {
      "items": _vm.players
    },
    on: {
      "remove": _vm.removePlayer
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(props) {
        return _c('player-cell', {
          attrs: {
            "cell-data": props.itemdata,
            "cell-index": props.itemindex
          }
        })
      }
    }])
  }), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.onPlayerSubmit($event)
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.name),
      expression: "name",
      modifiers: {
        "lazy": true
      }
    }],
    ref: "inputPlayer",
    staticClass: "new-player-name text-input",
    attrs: {
      "type": "text",
      "placeholder": "Ajouter un joueur"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "change": function($event) {
        _vm.name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "button color-blue-500 start-button",
    attrs: {
      "disabled": _vm.playersInGame.length < 2
    },
    on: {
      "click": function($event) {
        _vm.startGame()
      }
    }
  }, [_vm._v("Nouvelle partie")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a916ada8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PlayerList.vue
// module id = 116
// module chunks = 2